import React, { useState } from 'react';
import './admin.css'
import ImageUploader from '../ImageUploader/ImageUploader';
import { BASE_URL, passwordPattern } from '../../constants';
import Loader from '../Loader/Loader';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const AddStudent = () => {

    const userToken = localStorage.getItem('frotaToken')
    // State variables to store form inputs
    const [isLoading, setIsLoading] = useState(false);

    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [credits, setCredits] = useState('');
    const [clientDescription, setClientDescription] = useState('');
    const [profileImage, setProfileImage] = useState(null);

    const [viewPassword, setViewPassword] = useState(false);

    // Function to handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name) {
            toast.warn('Please Enter a Name');
            return;
        }
        if (!phone) {
            toast.warn('Please Enter a Phone Number.');
            return;
        }
        if (!email) {
            toast.warn('Please Enter an Email Address.');
            return;
        }
        if (!password) {
            toast.warn('Please Enter a Password.');
            return;
        }
        // if (!address) {
        //     toast.warn('Please Enter an Address.');
        //     return;
        // }
        // if (!clientDescription) {
        //     toast.warn('Please Enter a Description.');
        //     return;
        // }

        const isValidPassword = passwordPattern.test(password);
        if (!isValidPassword) {
            toast.error('Password must contain at least One Uppercase letter, One Lowercase letter, One Number, and One Special Character, and be at least 8 characters long.')
            return;
        }

        setIsLoading(true);

        const formData = new FormData();
        formData.append('name', name);
        formData.append('phone', phone);
        formData.append('email', email);
        formData.append('password', password);
        formData.append('credits', credits);
        
        if(address) {
            formData.append('address', address);
        }

        if(clientDescription) {
            formData.append('description', clientDescription);
        }
        
        if (profileImage) {
            formData.append('image', profileImage);
        }

        try {
            const response = await fetch(`${BASE_URL}admin/student_sign_up`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${userToken}`
                },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    toast.success('Student Created Successfully.');
                    setIsLoading(false);

                    // alert(data.message);
                }
                // console.log('Student sign-up successful:', data);
                // Handle successful sign-up, such as displaying a success message
                return data; // Return data if further processing is needed
            } else {
                // Handle sign-up failure
                const error = await response.json();
                console.error('Student sign-up failed:', error);
                toast.error(error.message);
                setIsLoading(false);

                // Handle error, such as displaying an error message
                throw new Error('Student sign-up failed'); // Throw error for further handling
            }
        } catch (error) {
            console.error('An error occurred:', error);
            // Handle network errors or other exceptions
            setIsLoading(false);
            throw new Error('An unexpected error occurred'); // Throw error for further handling
        }


        // Clear form fields after submission
        clearForm();
    };


    // Function to clear form fields
    const clearForm = () => {
        setName('');
        setAddress('');
        setPhone('');
        setEmail('');
        setClientDescription('');
    };

    return (
        <div className='add-student-container'>
            <Loader isLoading={isLoading} />
            <form onSubmit={handleSubmit}>
                <h2 className='title'>ADD STUDENT</h2>
                <div className="form-container">
                    <div className="left-container">
                        <div className='form-field'>
                            <label htmlFor='name'>Name: </label>
                            <input
                                type="text"
                                id="name"
                                value={name}
                                placeholder="Enter Student's Name"
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                        <div className='form-field'>
                            <label htmlFor='email'>Email: </label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                placeholder="Enter Student's Email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className='form-field'>
                            <label htmlFor='phone'>Phone: </label>
                            <input
                                type="text"
                                id="phone"
                                value={phone}
                                placeholder="Enter Phone Number"
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>
                        <div className='form-field'>
                            <label htmlFor='password'>Password: </label>
                            <input
                                type={viewPassword ? 'text' : 'password'}
                                id="password"
                                value={password}
                                placeholder="Enter Student's Password"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div className='view-password-icon-container'>
                                <FontAwesomeIcon
                                    icon={viewPassword ? faEye : faEyeSlash}
                                    onClick={() => setViewPassword(!viewPassword)}
                                    className='view-password-icon' />
                            </div>
                        </div>
                        <div className='form-field'>
                            <label htmlFor='credits'>Credits: </label>
                            <input
                                type="number"
                                id="credits"
                                value={credits}
                                placeholder="Enter Credits"
                                onChange={(e) => setCredits(e.target.value)}
                            />
                        </div>


                    </div>
                    <div className="right-container">
                        <ImageUploader setProfileImage={setProfileImage} />
                    </div>
                </div>

                <div className="bottom-container">
                    <div className='form-field'>
                        <label htmlFor='address'>Address: </label>
                        <input
                            type="text"
                            id="address"
                            value={address}
                            placeholder="Enter Student's Address"
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </div>
                    <div className='form-field'>
                        <label htmlFor='clientDescription'>Client Description: </label>
                        <textarea
                            type="text"
                            id="clientDescription"
                            value={clientDescription}
                            rows={4}
                            placeholder='Enter Some Client Description...'
                            onChange={(e) => setClientDescription(e.target.value)}
                        />
                    </div>

                    <div className="btn-container">
                        <button type="submit" className='submit-btn'>Add Student</button>
                    </div>
                </div>

            </form>
        </div>
    )
}

export default AddStudent;
